import { Count } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import { MUTATION_SET_COUNT } from "../gql/mutations";
import { countReducer, TCountAction } from "../reducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export const CountContext = createContext<
  IObjectContextType<Count, TCountAction>
>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

CountContext.displayName = "Count Context";

export const countInitState = {
  key: "",
  countValue: { total: 0 },
};

const CountProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    CountContext,
    countReducer,
    countInitState,
    children,
    MUTATION_SET_COUNT
  );

export default CountProvider;
